export default {
  entityName: "FiscalYear",
  apiEndpoint: "/master/fiscal-years",
  permissions: {
    view: "master:view",
    edit: "master:edit",
  },
  columns: [
    { key: "name", label: "Fiscal Name", sortable: true },
    { key: "code", label: "Period Code", sortable: true, class: () => "font-mono font-bold" },
    { key: "startDate", label: "Start Date", sortable: true, formatter: (val) => val ? new Date(val).toLocaleDateString() : "" },
    { key: "endDate", label: "End Date", sortable: true, formatter: (val) => val ? new Date(val).toLocaleDateString() : "" },
    { key: "isCurrent", label: "Active Period", sortable: true, formatter: (val) => val ? "Yes" : "No" },
  ],
  fields: [
    { name: "name", label: "Period Name", type: "text", required: true, placeholder: "e.g. FY 2026-27" },
    { name: "code", label: "Period Code", type: "text", required: true, uppercase: true, placeholder: "e.g. FY26" },
    { name: "startDate", label: "Start Date", type: "date", required: true },
    { name: "endDate", label: "End Date", type: "date", required: true },
    { name: "isCurrent", label: "Set as Active Accounting Year", type: "checkbox", default: false },
    
    // Advanced options
    { name: "effectiveFrom", label: "Effective From", type: "date", advanced: true },
    { name: "effectiveTo", label: "Effective To", type: "date", advanced: true },
  ],
  filters: [],
  workflow: {
    type: "fiscal_year_approval",
    enabled: true,
  },
};
